export default "__VITE_ASSET__Pfhglb2F__"